import { Component, Input } from '@angular/core';

@Component({
    selector: 'lib-rdata-badge',
    templateUrl: './rdata-badge.component.html',
    styleUrls: ['./rdata-badge.component.scss'],
    standalone: false
})
export class RdataBadgeComponent {

  @Input() value: string;
  @Input() trend: 'positive' | 'negative' = 'positive';
}
